// eslint-disable-next-line import/prefer-default-export
export const SPACE_SELECTOR_HEIGHT = 147;
